import script from "./ModalCtrl.mixin.vue?vue&type=script&lang=js"
export * from "./ModalCtrl.mixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__